import {
  useMapAtom,
  useMapAtomSetter,
  useMapAtomValue,
} from 'hooks/useMapAtom';
import { Atom, PrimitiveAtom, useAtom, useAtomValue, useSetAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { useCallback, useMemo } from 'react';
import { createMapStorage } from 'util/createMapStorage';

export type MatterDocumentSort = 'date-added' | 'date-modified' | 'name';

const mapStorage = createMapStorage<MatterDocumentSort>();
export const sortedMatterDocumentsAtom = atomWithStorage<
  Map<string, MatterDocumentSort>
>('sortedMatterDocuments', new Map(), mapStorage);

export function useSortedMatterDocuments(id: string) {
  return useMapAtomValue(sortedMatterDocumentsAtom, id, 'date-added');
}

export function useSortedMatterDocumentsSet(id: string) {
  return useMapAtomSetter(sortedMatterDocumentsAtom, id);
}

// Combine them into one hook returning [value, setter]
export function useSortedMatterDocumentsAtom(id: string) {
  return useMapAtom(sortedMatterDocumentsAtom, id, 'date-added');
}
